import { useState } from 'react';

import { Button, Flex, Tooltip } from '@vimeo/bokeh';
import { humanize, translate } from '@vimeo/i18n-runtime';

import { AnimatedLikeIcon } from './AnimatedLikeIcon';

export interface LikeButtonProps {
  isLiked: boolean;
  isDisabled?: boolean;
  likesCount?: number;
  isLoading?: boolean;
  disableTooltips?: boolean;
  variant?: 'minimal' | 'secondary';
  onLikeClick?: () => void;
}

export const AnimatedLikeButton: React.FC<LikeButtonProps> = ({
  isLiked,
  isDisabled = false,
  likesCount,
  isLoading = false,
  disableTooltips = false,
  variant = 'minimal',
  onLikeClick,
}) => {
  const [isAnimating, setIsAnimating] = useState(false);

  const handleClick = () => {
    if (isLoading) return;
    if (!isLiked) {
      setIsAnimating(true);
    }
    onLikeClick?.();
  };

  const likesCountString = humanize(likesCount ?? 0);

  return (
    <Tooltip
      label={isLiked ? translate('Unlike') : translate('Like')}
      isDisabled={disableTooltips}
      placement="top"
      closeOnClick={false}
    >
      <Button
        onClick={handleClick}
        variant={variant}
        size="sm"
        leftIcon={
          <AnimatedLikeIcon
            likedVideo={isLiked}
            isAnimating={isAnimating}
            setIsAnimating={setIsAnimating}
          />
        }
        isDisabled={isLoading || isDisabled}
        _disabled={{
          opacity: 1,
        }}
        data-type="icon-button"
        zIndex={1}
      >
        {likesCount ? (
          <Flex width={`${likesCountString.length * 0.5}rem`} textAlign="left">
            {likesCountString}
          </Flex>
        ) : null}
      </Button>
    </Tooltip>
  );
};
